import { useState, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@/utils/constants";
import { pointBusinessStatisticsService, IVRMPointBusinessStatisticsSearchFields, IVRMPointBusinessStatisticsDetail, IStatistics } from "./pointBusinessStatisticsService";
import useGlobalModel from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";
import { transPgToPagination } from "@/utils/utils";


export const usePointBusinessStatisticsModel = createModel(function () {
    const initStatistics = {
        saleNum: 0,
        saleAmount: 0,
        giftsNum: 0,
        giftsAmount: 0,
        costAmount: 0,
        profit: 0
    }
    const { shopAndOrg: { shopId, shopType }, setLoadingInfo } = useGlobalModel();
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IVRMPointBusinessStatisticsSearchFields>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<IVRMPointBusinessStatisticsDetail[]>([]);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [loading, setLoading] = useState<boolean>(false);
    const [descTotal, setDescTotal] = useState<IStatistics>(initStatistics);

    const updateSearchParam = (updateParam: IVRMPointBusinessStatisticsSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    const loadData = async (page?: ISearchPage, searchValue: IVRMPointBusinessStatisticsSearchFields = searchParam) => {
        setLoading(true);
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopType,
            shopId: searchValue.shopId ?? shopId
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            startTime: searchValue?.startTime ? searchValue?.startTime.replace(/T/g, " ") : "",
            endTime: searchValue?.endTime ? searchValue?.endTime.replace(/T/g, " ") : "",
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await pointBusinessStatisticsService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(origin =>
            records?.map((item, index) => ({ ...item, id: index + "1" })));
        setLoading(false);
        // let { retData: Data } = await pointBusinessStatisticsService.statistics(searchParams);
        // setDescTotal(Data);

    }

    //导出
    const exportSoList = async (searchValue: IVRMPointBusinessStatisticsSearchFields = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" })
        try {
            const shopParam = {
                shopType: searchValue.shopId !== undefined ? 1 : shopType,
                shopId: searchValue.shopId ?? shopId
            };
            const searchParams = {
                startTime: searchValue?.startTime ? searchValue?.startTime.replace(/T/g, " ") : "",
                endTime: searchValue?.endTime ? searchValue?.endTime.replace(/T/g, " ") : "",
                ...searchValue,
                ...shopParam,
                id: selectedRowKeys.join(),
                pageSize: -1,
                pageNum: 1,
            }
            let result = await pointBusinessStatisticsService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg, loading,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData, exportSoList,
        descTotal, setDescTotal
    }
});


